import { EntityConfig } from "../..";

export const PedidosOrcamentoConfig: EntityConfig = [
	{
		id: "id",
		label: "Id",
		type: "id",
		nonEditable: true,
	},
	{
		id: "title",
		label: "Título",
		type: "text",
		filterable: true,
	},
	{
		id: "sender",
		label: "Remetente",
		type: "text",
		filterable: true,
	},
	{
		id: "receiver",
		label: "Destinatário",
		type: "text",
		filterable: true,
	},
	{
		id: "estadoPedidoOrcamento",
		label: "Estado",
		type: "enum",
	},

	{
		id: "created_at",
		label: "Criado em",
		type: "date",
	},
];
